export default __webpack_public_path__ + "static/media/food.c4aba569.png";